import axiosInstance from './axiosInstance';

/**
 * 리뷰 작성
 * @param {{ applicationId, rating, comment }} data
 * @returns {{ id: number }}
 */
export const createReview = async (data) => {
  const res = await axiosInstance.post('/api/reviews', data);
  return res.data;
};
